<div class="pipeline" #pipelineComponent>
    <div class="pipeline-header">
        <h6 class="pipeline-header-title">
            {{filter?.area ? filter.area.nome : 'TODAS ÁREAS' | uppercase}}
        </h6>
        <h6 class="pipeline-header-total">
            <span class="pipeline-header-total-value">
                {{pipeline?.quantidadeCampanhas | decimalFormat: 1:0:0}} {{pipeline?.quantidadeCampanhas | campanhaCountLabel}}
            </span>
        </h6>
    </div>
    <div class="pipeline-content" cdkDropListGroup cdk-scrollable orientation="horizontal">
        <ng-template ngFor let-list let-listIndex="index" [ngForOf]="pipeline?.lists">
            <div class="pipeline-step" 
                [class.pipeline-step-collapsed]="list.isCollapsed"
                [class.pipeline-step-nao-confirmada]="list.isStatusNaoConfirmada"
                [class.pipeline-step-em-analise]="list.isStatusEmAnalise"
                [class.pipeline-step-em-andamento]="list.isStatusEmAndamento"
                [class.pipeline-step-reprovada]="list.isStatusReprovada"
                [class.pipeline-step-em-revisao]="list.isStatusEmRevisao"
                [class.pipeline-step-encerrada]="list.isStatusEncerrada"                
                [class.is-dragging]="pipeline.isDragging">
                
                <div class="pipeline-step-collapsed-content" *ngIf="list.isCollapsed">
                    <div class="pipeline-step-header"
                        [style.backgroundColor]="list.color">
                        <button class="btn btn-link pipeline-step-btn-toggle-collapse" (click)="toggleList(list)">
                            <i class="fas fa-chevron-right"></i>
                        </button>
                    </div>
                    <div class="pipeline-step-body"
                        cdkDropList
                        [id]="list.id"
                        [cdkDropListData]="list.entities"
                        (cdkDropListDropped)="drop($event, list)">
                        <h6 class="pipeline-step-title">
                            {{list.title}}  
                        </h6>
                        <div class="pipeline-step-header-total">                          
                            <h6 class="pipeline-step-header-total-value">
                                {{list.total?.quantidadeCampanhas | decimalFormat: 1:0:0}} {{list.total?.quantidadeCampanhas | campanhaCountLabel}}
                            </h6>                        
                        </div>
                    </div>
                </div>

                <div class="pipeline-step-content" *ngIf="!list.isCollapsed">
                    <div class="pipeline-step-header"
                        [style.backgroundColor]="list.color">

                        <div class="pipeline-step-header-main">
                            <h6 class="pipeline-step-title">
                                {{list.title}} <small>{{list.total?.quantidadeCampanhas | decimalFormat: 1:0:0}} {{list.total?.quantidadeCampanhas | campanhaCountLabel}}</small> 
                            </h6>

                            <div class="pipeline-step-widgets">
                                <sgt-campanha-roi-pipeline-widgets
                                    [roi]="list.total?.resultado?.roi"
                                    titleColor="#ffffff"
                                    subTitleColor="#ffffff">
                                </sgt-campanha-roi-pipeline-widgets>
                            </div>
                        </div>

                        <div class="pipeline-step-header-side">                     
                            <div class="pipeline-step-header-options">
                                <div class="dropdown">
                                    <button type="button" class="btn btn-link dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" tabindex="-1">
                                        <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
                                    </button>
                                    <div class="dropdown-menu">
                                        <div class="dropdown-item dropdown-item-toggle-cards-collapses" [class.disabled]="list.isCardsCollapsesOpening" onclick="event.stopPropagation()">
                                            <span *ngIf="list.isCardsCollapsesOpening">
                                                <i class='fas fa-spinner fa-pulse'></i> Expandir Todos
                                            </span>
                                            <div class="custom-control custom-switch" *ngIf="!list.isCardsCollapsesOpening">
                                                <input type="checkbox" class="custom-control-input" [ngModel]="list.isCardsCollapsesOpened" (ngModelChange)="toggleCardsCollapses(list, listIndex, $event)" name="isCardsCollapsesOpened_{{listIndex}}" id="isCardsCollapsesOpened_{{listIndex}}">
                                                <label class="custom-control-label" for="isCardsCollapsesOpened_{{listIndex}}"> Expandir Todos</label>
                                            </div>
                                        </div>                                      
                                    </div>
                                </div>            
                            </div>    
                            <button class="btn btn-link pipeline-step-btn-toggle-collapse" (click)="toggleList(list)">
                                <i class="fas fa-chevron-left"></i>
                            </button>                                                                      
                        </div>
                    </div>
                    <div class="pipeline-step-body"
                        infiniteScroll
                        [infiniteScrollDistance]="1"
                        [infiniteScrollThrottle]="500"
                        [scrollWindow]="false" 
                        (scrolled)="searchEntities(list)"
                        cdkDropList
                        [id]="list.id"
                        [cdkDropListData]="list.entities"
                        (cdkDropListDropped)="drop($event, list)">
                        <p class="text-center text-muted" *ngIf="list.isLoading">
                            <i class='fas fa-spinner fa-pulse'></i> Carregando
                        </p>                    
                        <sgt-campanha-pipeline-card
                            *ngFor="let entity of list.entities"
                            #pipelineCard
                            [listIndex]="listIndex"
                            [listColor]="list.color"
                            [isStatusNaoConfirmada]="list.isStatusNaoConfirmada"
                            [isStatusEmAnalise]="list.isStatusEmAnalise"
                            [isStatusEmAnamento]="list.isStatusEmAndamento"
                            [isStatusReprovada]="list.isStatusReprovada"
                            [isStatusEmRevisao]="list.isStatusEmRevisao"
                            [isStatusEncerrada]="list.isStatusEncerrada"
                            [optionsVisibility]="optionsVisibility"
                            [entity]="entity"
                            [filter]="filter"
                            [draggable]="true"
                            [cdkDragDisabled]="!canDragAndDrop(entity)"
                            cdkDrag
                            [cdkDragData]="entity" 
                            [cdkDragStartDelay]="50"                            
                            (cdkDragStarted)="onDragStarted()"
                            (cdkDragDropped)="onDragDropped()"
                            (edit)="edit($event, list)"
                            (visualizar)="visualizar($event)"
                            (delete)="delete($event)"
                            (solicitarAnalise)="solicitarAnalise($event, list)"
                            (aprovarAnalise)="aprovarAnalise($event, list)"
                            (reprovarAnalise)="reprovarAnalise($event, list)"
                            (encerrar)="encerrar($event, list)"
                            (liberarPedidos)="liberarPedidos($event, list)">
                            <div class="pipeline-card-placeholder" *cdkDragPlaceholder></div>
                        </sgt-campanha-pipeline-card>
                    </div>
                </div>
            </div>       
        </ng-template>
    </div>
</div>

<!-- Enviar Análise -->
<sgt-campanha-enviar-analise-form-modal
    #enviarAnaliseFormModal
    (afterEnviarAnalise)="onAfterEnviarAnalise($event)">
</sgt-campanha-enviar-analise-form-modal>

<!-- Visualizar Campanha -->
<sgt-campanha-visualizar-modal
    #visualizarModal
    (afterLiberarPedidos)="afterLiberarPedidos()">
</sgt-campanha-visualizar-modal>